import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import ErrorPage from "../error/404";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleHalfStroke, faClock, faGlobe, faLocationDot, faMedal, faMoneyBill, faPieChart, faUserGear, faUserPlus, faUsers } from "@fortawesome/free-solid-svg-icons";
import { jdlResultProps } from "../../../utils/types";
import { useState, useEffect } from "react";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { GET_JDL_BY_ID_END_POINT } from "../../../config/config";

const RequirementsDetails  = () => {
    const [requirements, setRequirements] = useState<jdlResultProps | null>(null);

    const {company, position_title, id} = useParams();

    useEffect(()=>{
        const getRequirements = async() => {
            try{
                const roleData = await api.get(GET_JDL_BY_ID_END_POINT+id, {
                    headers: { 'Authorization': 'Bearer ' + getToken() }
                });
                const reqData = roleData.data[0] as jdlResultProps;
                setRequirements(reqData);
            }catch(e){}
        }
        getRequirements();
    },[id]);
    
    if(!company || !position_title || !id) return (<ErrorPage />);
    
    const decodedTitle = decodeURIComponent(position_title);

    return(
        <div className="p-8">
            <Helmet>
                <title>{decodedTitle}</title>
            </Helmet>
            <div className="border p-4 shadow-xl w-full rounded relative">
                <div>
                    <h1 className="text-orange-500 font-semibold text-2xl">
                        {company}
                    </h1>
                </div>
                <div className="text-center">
                    <h1 className="text-gray-600 font-semibold text-xl underline">
                        {decodedTitle}
                    </h1>
                </div>
                <div className="w-full flex gap-4 mt-6 text-lg text-gray-600">
                    <div className="flex flex-col w-full gap-4">
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faGlobe} />&nbsp;
                                Domain: 
                            </p>
                            <p className="hover:underline">
                                {requirements?.domain_name}
                            </p>
                        </div>
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faPieChart} />&nbsp;
                                Segment: 
                            </p>
                            <p className="hover:underline">
                                {requirements?.segment_name}
                            </p>
                        </div>
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faCircleHalfStroke} />&nbsp;
                                Sub-segment: 
                            </p>
                            <p className="hover:underline">
                                {requirements?.sub_segment_name}
                            </p>
                        </div>
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faLocationDot} />&nbsp;
                                Location: 
                            </p>
                            <p className="hover:underline">
                                {requirements && requirements.location ? requirements.location : 'Not specified'}
                            </p>
                        </div>
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faClock} />&nbsp;
                                Shift Schedule:
                            </p>
                            <p className="hover:underline">
                                {requirements?.shift_schedule !== null ? requirements?.shift_schedule : 'Not specified'}
                            </p>
                        </div>
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faMoneyBill} />&nbsp;
                                Budget:
                            </p>
                            <p className="hover:underline">
                                {requirements?.budget}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-4">
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faUsers} />&nbsp;
                                FTE:
                            </p>
                            <p className="hover:underline">
                                {requirements?.fte}
                            </p>
                        </div>
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faUserPlus} />&nbsp;
                                Updated FTE:
                            </p>
                            <p className="hover:underline">
                                {requirements?.updated_fte}
                            </p>
                        </div>
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faMedal} />&nbsp;
                                Career Level:
                            </p>
                            <p className="hover:underline">
                                {requirements?.career_level}
                            </p>
                        </div>
                        <div className="flex gap-4 justify-start items-center">
                            <p className="font-semibold">
                                <FontAwesomeIcon icon={faUserGear} />&nbsp;
                                Status:
                            </p>
                            <p className="hover:underline">
                                {requirements?.status}
                            </p>
                        </div>
                    </div>
                    
                </div>
                <div className="w-full mt-6">
                    <div className="my-4">
                        <h1 className="font-semibold">Job Description: </h1>
                    </div>
                    <div className="relative">
                        <textarea className="w-full max-h-[40rem] min-h-[40rem] outline-none p-4" readOnly value={requirements?.job_description}></textarea>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RequirementsDetails;